import { useLiveQuery } from 'dexie-react-hooks'
import { db } from '@/lib/db'

// Conteo reactivo de borradores pendientes (retiros + entregas) vía IndexedDB.
export function usePendingSyncCount(): number {
  return useLiveQuery(
    async () => {
      const [pickups, deliveries] = await Promise.all([
        db.pickup_records_draft.where('pending_sync').equals(1).count(),
        db.delivery_drafts.where('pending_sync').equals(1).count(),
      ])
      return pickups + deliveries
    },
    [],
    0,
  ) as number
}
